/**
 * Created by chenqifeng on 2016/8/24.
 */
import $                  from 'jquery';
import maple              from 'maple';
import domain             from './domain';
import weChat             from './weChat';
import * as api           from './api/index';
import tgs                from './analyse';
import app                from './app/index';
import {request}          from './http';
import * as base          from './base';
import {positionRun}      from './asyncTask/autoPosition';
import {checkLoginRun}    from './asyncTask/checkLogin';
import {loadWcSdk}        from './asyncTask/loadWcSdk';
import {loadAppInterface} from './asyncTask/loop_app_interface';
import deleteUrlParams    from '../../../setting/deleteUrlParams.json';
import currentPageCode    from '../../../setting/currentPageCode.json';
import AppPageCode        from '../../../setting/AppPageCode.json';
import isNeedLoginPath    from '../tg/util/isNeedLoginPath';
import nodelog            from '../tg/util/nodelog';
import scpCheck           from './scpCheck';
import tgSession          from 'javascript/libs/tg/util/tgSession';

//const dynamicWcShareDeferred = $.Deferred();
let webOver = false // 页面是否加载完成
    , needServerData = false    // 初始化页面是否需要服务端数据
    , loaddingState = 'done'
    , loadingList = []
    , loadMoreUrl = ''
    , loadCount = 1
    , pageViewList = {}
    , pageMinView = 1
    , $window = $(window)
    , traceProductList = [],
	allTraceProductList = [],
	// 曝光定时器
	traceTimer = null,
	inObserver = null
    ;

if( maple.cookie('hybrid') === 'true' ){    // 2017-08-02 app 下传参添加 app 版本号
	api.imSer._getByMemberId = api.imSer.getByMemberId;
	api.imSer.getByMemberId = function(params){
		params.data.tgAppVersion = app.getTgAppVersion();

		this._getByMemberId( params );
	};
	api.imSer._getServiceList = api.imSer.getServiceList;
	api.imSer.getServiceList = function(params){
		params.data.tgAppVersion = app.getTgAppVersion();

		this._getServiceList(params);
	};
}

const memberInfoDeferred = $.Deferred()
    , cityDeferred = $.Deferred()
    , loadWcSdkDeferred = $.Deferred()
    , appInterfaceDeferred = $.Deferred()
    , insArray = []
    ;

class Page{
	/**
	 * @param init  {Function}  外部初始化函数，未来可扩展为属性参数
	 *
	 * */
	constructor(init){
		if( init && typeof init === 'function' ){
			init.call( this );
		}
	}

	/**
	 * 入口
	 * @param initPage
	 */
	_initPage(initPage){
		let that = this
            ;

		// 为 jQuery 添加滚动开始和滚动结束事件
		this.addScrollEventToJquery( $ );

		// 为 jQuery 添加是否在视窗内的方法
		this.addIsInViewToJquery( $ );

		// 初始化框架配置信息
		this._initDefaultSetting();

		// 初始化运行环境
		this._initGlobal();

		// 设置初始化参数
		this._initParams();

		// 初始化 url
		this._initUrl();

		// app 下特殊处理
		this._initAppPage();

		// 绑定点击事件
		this._initLinksEvent();

		// 初始化回到顶部按钮
		this._initScrollUp();

		// 自动统计
		this._initAutoAnalyse();

		// 自动曝光
		this._initAutoBaoguang();

		// 自动拉起 app
		this._autoRunApp();

		// 绑定滚动加载更多
		this._scrollLoadMore();

		// 设置初始 InitURL
		this._initUrlInCookie();

		// 检查 webp 支持
		this._initCheckWebp();

		// 全局获取客服电话并存入session
		this._getKefuTel();

		scpCheck();

		// 在页面滚动的时候为 body 添加 pageScrollIng 类
		this.addScrollClass();

		$.when( loadWcSdkDeferred ).done(()=>{
			// 执行业务代码
			this.runBusinessCode(initPage, function(){
				!needServerData && that._overHandler();
			});
		}).fail(()=>{
			// 执行业务代码
			this.runBusinessCode(initPage, function(){
				!needServerData && that._overHandler();
			});
		});
		loadWcSdk( loadWcSdkDeferred );

		this.needRefresh && this._initNeedRefresh();

		if( !this.needRefresh ){
			// 当前页面没有回退刷新机制
			this._pageBackSetScrollBar();
		}
	}

	/**
	 * 数据格式化，解决 loadmore 时黑盒问题
	 * */
	dataFormat(data){
		return data;
	}

	/**
	 * 在页面滚动的时候为 body 添加 pageScrollIng 类
	 */
	addScrollClass(){
		let body = $('body')
            , isScrolling = false
            , fn = _.debounce(function(){
				body.removeClass('pageScrollIng');
				isScrolling = false;
			}, 50)
            ;

		$(window).on('scroll', function(){
			if( isScrolling === false ){
				isScrolling = true;
				body.addClass('pageScrollIng');
			}

			fn();
		});
	}

	/**
	 * 为 jQuery 添加滚动开始和滚动结束事件
	 */
	addScrollEventToJquery($){
		let dispatch = $.event.dispatch || $.event.handle
            , special = $.event.special
            , uid1 = 'D' + +new Date
            , uid2 = 'D' + (+new Date + 1)
            ;

		special.scrollstart = {
			setup: function(data){
				let timer
                    , _data = $.extend({
						latency: special.scrollstop.latency
					}, data)
                    , handler = function(evt){
						let _self = this
                            ;

						if( timer ){
                            clearTimeout( timer );
                        }
						else{
                            evt.type = 'scrollstart';

                            dispatch.apply(_self, arguments);

                            timer = setTimeout(function(){
                                timer = null;
                            }, _data.latency);
                        }
					}
					;

				$(this).bind('scroll', handler).data(uid1, handler);
			}
			, teardown: function(){
				$(this).unbind('scroll', $(this).data( uid1 ));
			}
		};
		special.scrollstop = {
			latency: 250
            , setup: function(data){
				let timer
                    , _data = $.extend({
						latency: special.scrollstop.latency
					}, data)
                    , handler = function(evt){
						let _self = this
                            , _args = arguments
                            ;

						if( timer ){
                            clearTimeout( timer );

                            timer = setTimeout(function(){
                                timer = null;

                                evt.type = 'scrollstop';

                                dispatch.apply(_self, _args);
                            }, _data.latency);
                        }
					}
					;

				$(this).bind('scroll', handler).data(uid2, handler);
			}
			, teardown: function(){
				$(this).unbind('scroll', $(this).data( uid2 ));
			}
		};
	}

	addIsInViewToJquery($){
		$.fn.isInView = function(options){
			if( !this.length ){
				return false;
			}

			let opts = $.extend(true, {}, $.fn.isInView.defaults, options)
				, offset = $(this).eq(0).offset().top - (document.body.scrollTop || document.documentElement.scrollTop)
				, offsetY = $(this).eq(0).offset().top - (document.body.scrollTop || document.documentElement.scrollTop)
				, offsetX = $(this).eq(0).offset().left
				, inY = offsetY >= 0 && offsetY < document.documentElement.clientHeight
				, inX = offsetX >= 0 && offsetX < document.documentElement.clientWidth
				;

			return inY && inX;
		};
		// default options
		$.fn.isInView.defaults = {};
	}

	// traceProductList 中存在超过1500ms的才发曝光
	startBaoguang(){
		const that = this;
		traceProductList.forEach(item => {
			const etime = new Date().getTime();
			if (etime - item.stime >= 1500 && !item.hasBaoguang) {
				item.hasBaoguang = true;
				let scp = item.dom.getAttribute('data-scp');
				const bk = item.dom.getAttribute('data-bk');
				const storeId = item.dom.getAttribute('data-store-id');
				const ur = item.dom.getAttribute('data-ur');
				scp = (that.page || '*.*') + '.' + scp + '.' + Math.random().toString(36).slice(2, 7);
				tgs.baoguang(scp, bk, typeof item.traceId === 'symbol' ? undefined : item.traceId, storeId, ur);
			}
		})
	}

	updateTraceProductList(){
		let tempDom = [];
		$('[data-trace-id]').each(function(){
			let $temp = $(this), traceId = $temp.data('traceId');
			if( !traceId ){
				traceId = Symbol.for(`${$temp.data('scp')}${$temp.data('bk') || ''}`);
			}
			tempDom.push({
				dom: $temp,
				traceId
			});
		})
		// 找到tempDom 比 allTraceProductList多的元素进行观察，防止因多次的updateTraceProductList 方法导致元素被多次观察
		let diffList = [];
		tempDom.forEach((item) => {
			if (!allTraceProductList.some((itemA) => {return item.traceId === itemA.traceId})) {
				diffList.push(item)
			}
		})
		diffList.forEach(item =>{
			this.getInstance().observe(item.dom[0]);
		})
		allTraceProductList = _.unionBy(allTraceProductList, tempDom, 'traceId');
	}

	intersectionObserver() {
		inObserver = null;
		return new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					this.handleEnter(entry);
				} else {
					this.handleExit(entry);
				}
			});
		})
	}
	getInstance() {
		if (!inObserver) {
			inObserver = this.intersectionObserver();
		}
		return inObserver;
	}
	// 元素进入视图时，加入队列（已存在就不加入 traceId为唯一标识，stime为在视图上观测到该元素的时间）
	handleEnter(entry) {
		const dom =  entry.target;
		let traceId = dom.getAttribute('data-trace-id');
		const scp = dom.getAttribute('data-scp');
		const bk = dom.getAttribute('data-bk');
		const stime = new Date().getTime();
		const hasBaoguang = false;
		if( !traceId ){
			traceId = Symbol.for(`${scp}${bk || ''}`);
		}
		const observeData = { traceId, dom, stime, hasBaoguang };
		let flag = traceProductList.some(item => {
			return item.traceId === traceId;
		})
		if (!flag) traceProductList.push(observeData);
	}
	// 元素离开视图时，如果满足时间且没有发曝光 则发曝光，将该元素从队列里删除
	handleExit(entry) {
		const that = this;
		const dom = entry.target;
		// 为防止误删，再判断一遍该dom是不是在可视区域内（目前可视区域就指设备全屏，没算其他dom遮挡）
		if (this.isInViewport(dom)) {
			return;
		}
		let traceId = dom.getAttribute('data-trace-id');
		let scp = dom.getAttribute('data-scp');
		const bk = dom.getAttribute('data-bk');
		const etime = new Date().getTime();
		if( !traceId ){
			traceId = Symbol.for(`${scp}${bk || ''}`);
		}
		traceProductList.forEach(item => {
			if (item.traceId === traceId && !item.hasBaoguang && etime - item.stime > 1500) {
				item.hasBaoguang = true;
				const storeId = item.dom.getAttribute('data-store-id');
				const ur = item.dom.getAttribute('data-ur');
				scp = (that.page || '*.*') + '.' + scp + '.' + Math.random().toString(36).slice(2, 7);
				tgs.baoguang(scp, bk, typeof item.traceId === 'symbol' ? undefined : item.traceId, storeId, ur);
			}
		})
		traceProductList = traceProductList.filter(item =>{return item.traceId !== traceId})
	}

	getServerTime(callback){
		request({
			url: domain.baseMidService + '/base/timestamp.node'
			, success(data){
				if( _.isFunction(callback) ){
					callback(_.isNumber(data) ? data : +new Date);
				}
			}
			, error(){
				callback( +new Date );
			}
		});
	}

	// 滚动结束调用
	scrollOverHandler(){

	}

	isInViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top >= 0 && rect.left >= 0
			&& rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
			&& rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		)
	}

	loadMidData(url, data, fn){
		this.useMidDataByStaticMethod = true;

		let that = this
			, options = {
				type: 'GET'
				, loadMore: true
			}
			;

		if( typeof arguments[0] == 'object' ){
			options = _.defaults(arguments[0], options);
		}
		else{
			options.url = url || loadMoreUrl;
			options.data = data || {};
			options.success = fn;
			options.format = $.proxy(that.dataFormat, that);
		}

		let currentPosition = _.get(maple.url(), 'params.currentPosition')
			, totalView
			, scrllTop
			;

		if( currentPosition ){
			if( /\d+_\d+/.test(currentPosition) ){
				totalView = currentPosition.split('_')[0];
				scrllTop = currentPosition.split('_')[1];
			}

			maple.url().replace('currentPosition');
		}

		if( totalView && !_.includes(options.url, 'currentView') ){
			options.url = that.addParams(options.url, {
				totalView: totalView
			});
			pageMinView = totalView;
			// 如果请求中间件时请求了多页(3 页)的数据，统计具体情况
			let message = {
					page: location.href
					, url: options.url
				}
				;

			if( totalView > 10 ){
				$.get('http://nodelog.51tiangou.com/log/custom/add', {
					key: 'currentPosition'
					, message: JSON.stringify( message )
				});
			}
		}

		if( loaddingState === 'done' && options.url ){
			if( options.loadMore ){
				loaddingState = 'loadding';
			}

			needServerData = true;
			options.beforeRequest && options.beforeRequest();

			request({
				url: options.url
				, cache: false
				, type: options.type
				, data: options.data
				, success: function(data=[], timestamp, code){
					if( _.get(_.last(arguments), 'httpCode') === 889
						&& !localStorage.getItem('ssoConfirmed')
						&& isNeedLoginPath(location.pathname) ){

						maple.alert({
							content: '您的账号已在其他终端登录，请重新登录'
							, okFn(){
								localStorage.setItem('ssoConfirmed', true);
								maple.pageIns && maple.pageIns.changePage('/login/login.html', {
									loginBack: encodeURIComponent( location.href )
								});
							}
						});

						return;
					}

					if( _.get(_.last(arguments), 'httpCode') === 888
						&& isNeedLoginPath(location.pathname) ){

						maple.pageIns && maple.pageIns.changePage('/login/login.html', {
							loginBack: encodeURIComponent( location.href )
						});

						return;
					}

					if( typeof options.before == 'function' ){
						options.before( data );
					}
					else if( typeof that.loadMidDataBefore === 'function' ){
						that.loadMidDataBefore( loadCount );
					}

					let comData = {}
						// 需要异步调用
						, asynUrl = _.get(data.filter( item=>item.key === 'editComponent' )[0], 'data.url')
						, listCom = that.listCom || [], cache = [];
					if (that.vm) {
						comData = JSON.stringify(that.vm.$data, (key, value) => {
							if (typeof value === 'object' && value !== null) {
								if (cache.indexOf(value) !== -1) {
									return;
								}
								// 收集所有的值
								cache.push(value);
							}
							return value;
						})
						comData = JSON.parse(comData);
					}
					cache = null;

					data.forEach(function(item){
						let key = item.key || item.name
							;

						if( typeof item.data === 'object' ){
							item.data.props = item.prop || {};

							if( _.isArray(item.data.items) && item.data.id ){
								_.forEach(item.data.items, (innerItem)=>{
									innerItem._parentId = item.data.id;
								});
							}
						}

						if( listCom.indexOf(key) < 0 ){
							comData[key] = item.data;
						}
						else{
							comData[key] = comData[key] || [];
							comData[key].push( item.data );
						}
					});

					if( !webOver ){
						that._overHandler();
						(options.callback || function(){})( comData );
					}

					if( typeof options.format == 'function' ){
						comData = options.format( comData );
					}

					let wcShareInfo = _.chain(data).filter( item=>item === 'wcShareInfo' ).get(0, {}).value()
						;

					that.dynamicWcShare = wcShareInfo.data || {};

					if( that.vm ){
						Object.keys( comData ).forEach(function(key){
							let vmCom = that.vm.$get( key );

							// 以下代码用作增量修改 VM 模型
							if( typeof comData[key] == 'object' ){
								if( !_.isEqual(comData[key], vmCom) ){
									if( _.isArray(vmCom) ){
										_.differenceWith(comData[key], vmCom, _.isEqual).forEach(item=>{
											vmCom.push( item );
										});
									}
									else{
										that.vm.$set(key, comData[key]);
									}
								}
								// that.vm.$set(key, comData[key]);
							}
							else if( key === 'emptyList' ){
								that.vm.$set(key, comData[key]);
							}
						});
						_.defer(function(){
							// 推荐品曝光
							if (_.isFunction( that.vm.loadMidWayMore )) {
								that.vm.loadMidWayMore(data, options.url)
							} else {
								that.updateTraceProductList();
							}
							scpCheck();
							_.isFunction( options.success ) && options.success();
						});
					}

					if( typeof options.after == 'function' ){
						options.after(comData, loadCount);
					}
					else if( typeof that.loadMidDataAfter == 'function' ){
						that.loadMidDataAfter( loadCount );
					}

					loaddingState = 'done';
					loadCount++;

					if( options.loadMore ){
						loadMoreUrl = comData.loadMore;
						setTimeout(function(){
							that.vm.$broadcast('midDataNoMore', !!loadMoreUrl);

							if( !loadMoreUrl ){
								that.scrollOverHandler();
							}

							that.$body[0].style.height = '';
							that.$body.height( that.$body.height() );

							let loadMoreView = that.vm.loadMoreView || 1;

							if( (maple.scrollBar('bottom').view < loadMoreView && !that.vm.domLoadMore) || (that.vm.domLoadMore && maple.scrollBar(['bottom', that.vm.domLoadMore]).view < loadMoreView) ){
								that.loadMore && that.loadMidData();
							}

							// 滚动到指定位置
							scrllTop && maple.scrollBar('top', scrllTop);
							// 保存每屏显示的范围
							_.set(pageViewList, 'pageView_' + _.max([
								(_.get(maple.url(options.url), 'params.currentView') || 1)
								, pageMinView
							]), that.$body.height());
							// maple.log(pageViewList)
						}, 0);
					}

					// 异步加载数据
					asynUrl && that.loadMidData({
						url: asynUrl
						, loadMore: false
					});
				}
				, error: function(){
					loaddingState = 'done';
				}
			});
		}
	}

	getLoadMoreUrl(){
		return loadMoreUrl;
	}

	setLoadMoreUrl(url){
		loadMoreUrl = url;
	}

	_isLoginPath(pathname, loginPathList){
		pathname = pathname.replace('/', '');

		return pathname !== 'index.html' && loginPathList.some(function(i){
			return !!~i.indexOf( pathname );
		});
	}

	_overHandler(){
		let that = this
			;

		webOver = true;
		app.tgWebOver();
		that._brownShare();
		maple.device.weixin && that._initWcShare();
	}

	_initCheckWebp(){
		let that = this
			, flg = that.getCookie('webp')
			;

		if( !flg ){
			let WebP = new Image()
				;

			WebP.onload = function(){
				if( WebP.height !== 2 ){
					that.setCookie('webp', 'false', '365d');
				}
				else{
					that.setCookie('webp', 'true', '365d');
				}
			};
			WebP.onerror = function(){
				that.setCookie('webp', 'false', '365d');
			};
			WebP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
		}
	}

	_getKefuTel() {
		if (!tgSession.getItem('kefuTel')) {
			api.base.getKefuTel({
				data:{},
				success(data){
					tgSession.setItem('kefuTel', data);
				}
			});
		}
	}

	_initUrlInCookie(){
		/**
		 * 如果 cookie 中不存在 initURL，则设置其值为当前 URL
		 * 在旧框架中的后退，会判断 initURL，如果没有值，则代表从其他网站进入的该页面，此时会跳转到首页
		 */
		let that = this
			, initUrl = that.getCookie('initUrl')
			;

		if( !initUrl ){
			that.setCookie('initUrl', location.href);
		}
	}

	_scrollLoadMore(){
		let that = this;
		$(document).on('scroll', function(){
			if( maple.scrollBar('bottom').view < 1 ){
				that.loadMore && that.loadMidData();
			}
		});
	}

	domScrollLoadMore() {
		let that = this;
		that.loadMore && that.loadMidData();
	}

	changePage(...arg){
		let that = this
			;

		if( _.isObject(arg[0]) ){
			let { href
				, data
				, isNeedRefresh
				, path
				, query } = arg[0]
				;

			href = that.addParams(href, data) + '#/' + that.addParams(path, query);
			this._assignPage('change', href, {}, isNeedRefresh);
		}
		else{
			let [href, data, isNeedRefresh = false] = [...arg]
				;

			this._assignPage('change', href, data, isNeedRefresh);
		}
	}

	replacePage(...arg){
		let that = this
			;

		if( _.isObject(arg[0]) ){
			let { href
				, data
				, isNeedRefresh
				, path
				, query } = arg[0]
				;

			href = that.addParams(href, data) + '#/' + that.addParams(path, query);
			this._assignPage('replace', href, {}, isNeedRefresh);
		}
		else{
			let [href, data, isNeedRefresh = false] = [...arg]
				;

			this._assignPage('replace', href, data, isNeedRefresh);
		}
	}

	_assignPage(type, href='', data={}, isNeedRefresh=false){
		// 对于自定义协议头的 URL 的处理
		let customProtocol = maple.url(href).protocol
			;

		if( !_.includes(['http', 'https'], customProtocol) ){
			request({
				url: (function(){
					let url
						;

					if( domain.env === 'online' ){
						url = '//' + customProtocol + '.51tiangou.com';
					}
					else{
						url = '//' + customProtocol + '.' + domain.env + '.66buy.com.cn';
					}

					url += maple.url(href).path.replace(/^\/+/, '/');

					return url;
				})()
				, data: _.mapValues(maple.url( href ).params, item=>decodeURIComponent( item ))
				, success(){
					if( customProtocol === 'coupon' ){
						maple.alert('领取成功');
					}
				}
			});

			return false;
		}

		let nowScroll = maple.scrollBar('top').px
			, nowView = !_.isEmpty(pageViewList) ? ((_.findKey(pageViewList, function(value){
				return value > nowScroll;
			}) || '').toString().match(/\d+/) || [1])[0] : 1
			;

		/**
		 * 2017-11-27 去掉页面跳转时若没有设置回退刷新，将位置信息添加到 url 的逻辑
		 *      页面回退时，依赖浏览器/ webview 默认行为
		 * */
		// //如果 changePage 没有设置刷新 && 请求了中间件，则在跳转时增加滚动位置
		// if( maple.device.android && maple.device.weixin ){
		//    !isNeedRefresh && this.useMidDataByStaticMethod && maple.url().replace({
		//        currentPosition: nowView + '_' + nowScroll
		//    });
		//    maple.log('当前currentPosition'+nowView+'_'+nowScroll)
		// }

		if( location.port === '8080' ){
			href = maple._.parseURL( href ).relative;
		}

		let that = this
			, locationHref = location.href
			, absUrl = ''
			, origin = ''
			, appCode = ''
			, i = 0
			, urlExpectedCode = domain.urlExpectedCode
			, length = urlExpectedCode.length
			, reg
			;

		for( ; i < length; i++ ){
			reg = new RegExp('(\\?' + urlExpectedCode[i] + '=|&' + urlExpectedCode[i] + '=)');

			if( urlExpectedCode[i] in data || reg.test(href) ){
				// alert(urlExpectedCode[i] + '为url保留字段，禁止使用,发现请立即修改');
			}
		}

		if( this.params && this.params.min ){
			data.min = this.params.min;
		}

		if( this.params && this.params.air ){
			data.air = this.params.air;
		}

		if( this.params && this.params.isWeixin ){
			data.isWeixin = this.params.isWeixin;
		}

		// 给 url 添加参数
		href = that.addParams(href, data);
		if( that.hybrid ){
			absUrl = that.toAbsUrl( href );
			type === 'change' && app.addTgHistory(locationHref, String(!!isNeedRefresh || that.needRefresh));
			origin = location.origin;
			appCode = AppPageCode[absUrl.replace(origin, '').replace(/\?.*/, '')];

			if( appCode ){
				app.tgChangePage(appCode, absUrl);
			}
		}

		if( type === 'change' ){
			try{
				app.addTgHistory(locationHref, String(!!isNeedRefresh || that.needRefresh));
			}
			catch(e){}

			!!isNeedRefresh && !that.needRefresh && this._initNeedRefresh();

			if( !isNeedRefresh ){
				this._pageBackSetScrollBar();
			}

			location.assign( href );
		}
		else{
			!!isNeedRefresh && !that.needRefresh && this._initNeedRefresh();

			if( !isNeedRefresh ){
				this._pageBackSetScrollBar();
			}

			location.replace( href );
		}

		// maple.util.everyTime({
		//     key: 'pageUnMask',
		//     fn: function () {
		//         var newPageInitTime = Number(that.getCookie('pageInitTime')) || new Date().getTime();
		//         if (that.pageInitTime < newPageInitTime) {
		//             if (!!isNeedRefresh || that.needRefresh) {
		//                 location.reload();
		//             } else {
		//                 maple.util.stopTime({
		//                     key: 'pageUnMask'
		//                 });
		//             }
		//         }
		//     },
		//     time: 100
		// });
	}

	/**
	 * 给 URL添加时间戳，清理浏览器缓存
	 * @param url
	 * @returns {string}
	 */
	timestamp(url) {
		//  var getTimestamp=Math.random();
		var getTimestamp = new Date().getTime();
		if (url.indexOf("?") > -1) {
			url = url + "&_=" + getTimestamp
		} else {
			url = url + "?_=" + getTimestamp
		}
		return url;
	}

	/**
	 * 页面是否需要重新渲染
	 * @private
	 * */
	_initNeedRefresh(){
		window.onpagehide = function(){
			window.onpageshow = function(){
				location.reload();
			};
		};

		// if( maple.device.ios ){
		//    // /**
		//    //  不调用 everyTime 函数
		//    //  使用 onpageshow 事件来实现浏览器回退刷新
		//    //  利用 onpagehide 事件在页面跳转走之前对页面添加 onpageshow 事件
		//    //  测试 onbeforeload 可以在 chrome 内核中可以实现相同的功能，但 Safari 不支持
		//    //  已测试在 UC 浏览器、微信（微信似乎是一直刷新的）、Safari 中测试
		//    //  todo 在测试 APP 上测试
		//    //  todo 提出为一个方法
		//    //
		//    //  * */
		//     window.onpagehide = function() {
		//        window.onpageshow = function() {
		//            location.reload();
		//        };
		//    };
		// }
		// else{
		//    /**
		//     * 由 onpageshow 与 onpagehide 组合改为 onunload 事件
		//     * */
		//    window.onunload = function(){};
		// }
	}

	_pageBackSetScrollBar(){
		window.onpageshow = ()=>{
			this._setScrollBar();
		};
	}

	_setScrollBar(){
		let currentPosition
			, totalView
			, scrllTop
			;

		// 环信似乎在全局声明了 _ 变量，但是没有 get 方法。。。
		try{
			currentPosition = _.get(maple.url(), 'params.currentPosition');
		}
		catch(e){
			currentPosition = '';
		}

		if( currentPosition ){
			if( /\d+_\d+/.test(currentPosition) ){
				totalView = currentPosition.split('_')[0];
				scrllTop = currentPosition.split('_')[1];
			}

			// todo 微信下替换 url 无效
			maple.url().replace('currentPosition');

			// 滚动到指定位置
			scrllTop && maple.scrollBar('top', scrllTop);
		}
	}

	/**
	 * 初始化默认参数
	 * @private
	 */
	_initDefaultSetting(){
		this.needRefresh = !!this.needRefresh;
		this.goToTop = this.goToTop || true;
		this.autoAnalyse = this.autoAnalyse !== undefined ? this.autoAnalyse : true;
		this.useWcShare = this.useWcShare !== undefined ? this.useWcShare : true;
		this.useGoTop = this.useGoTop !== undefined ? this.useGoTop : true;
		this.isWcAutoLogin = this.isWcAutoLogin !== undefined ? this.isWcAutoLogin : true;  // 是否需要微信自动登录
		this.isWcShare = !!this.isWcShare;  // 是否需要微信分享

		this.loadMore = !!this.loadMore || true;    // 是否可以加载更多数据
	}

	/**
	 * 初始化运行环境
	 * @private
	 */
	_initGlobal(){
		let that = this
			, global = that.getCookie('global')
			;

		if( global ){
			that.global = global;
		}
		else{
			if( navigator.userAgent.indexOf('AlipayClient') > 0 ){
				global = 'AlipayClient';
			}
			else if( maple.device.weixin ){
				global = 'wechat';
			}
			else{
				global = 'webapp';
			}

			that.setCookie('global', global);
		}
	}

	/**
	 * 初始化url
	 * @private
	 */
	_initUrl(){
		let url = location.pathname + location.search
			;

		if( this.scrollTop ){
			url = this.removeParams(url, 'scrollTop');
		}

		if( !maple.device.weixin ){
			this.replaceState(null, '', url);
		}
	}

	/**
	 * 初始化参数
	 * @private
	 */
	_initParams(){
		this.pageInitTime = new Date().getTime();
		this.setCookie('pageInitTime', this.pageInitTime);
		this.params = this.getUrlParams();
		this.scrollTop = Number(this.params.scrollTop && this.params.scrollTop.replace(/^\D*(\d*).*$/, '$1')) || 0;
		this.isBack = !!this.scrollTop;
		this.backOver = false;
		this.cityId = this.getCookie('cityId') && Number(this.getCookie('cityId'));
		this.cityName = this.getCookie('cityName');
		this.global = this.getCookie('global') || undefined;
		this.hybrid = this.getCookie('hybrid') === 'true';
		this.isAndroid = this.hybrid && this.global === 'android';
		this.isIos = this.hybrid && this.global === 'ios';
		this.isAirMall = this.getCookie('global') === 'airMall';
		this.$body = $('body');
		//this.App = App;

		if( this.params.source_type ){
			this.setCookie('source_type', this.params.source_type);
		}

		if( this.params.source_weixin_id ){
			this.setCookie('source_weixin_id', this.params.source_weixin_id);
		}

		if( this.params.shopid ){
			this.setCookie('shopid', this.params.shopid);
		}

		if( this.params.jr || this.params.JR ){
			this.setCookie('JR', this.params.jr || this.params.JR);
		}
	}

	/**
	 * app下特殊处理
	 * @private
	 */
	_initAppPage(){
		let that = this
			, classList = document.body.classList
			;

		if( this.hybrid ){
			classList.add('hybrid');
			classList.add( that.getCookie('global') );
		}
	}

	/**
	 * 绑定点击事件
	 * @private
	 */
	_initLinksEvent(){
		let that = this
			;

		that.$body.on('click', 'a', function(e){
			let $line = $(this)
				, href = $line.attr('href')
				, absHref = that.toAbsUrl(href)
				, scpCD = $(this).data('scp')
				, scp = scpCD ? (that.page + '.' + scpCD + '.' + Math.random().toString(34).slice(2, 2 + 5)) : undefined
				, reload = String($line.data('reload') || false) === 'true'
				;

			if( !$line[0] || !href || /^#/.test(href) || /java/.test(href) ){
				return;
			}
			else if( /tel/.test(href) ){
				location.href = href;
				e.preventDefault();
			}
			else{
				href = that.removeParams.apply(that, [href].concat(deleteUrlParams));
				href = that.addParams(href, {
					scp
				});
				that.changePage(href, {}, reload);
				e.preventDefault();
			}

			return false;
		}).on('click', '[data-scp]', function(){
			let traceId = $(this).data('traceId')
				, scp = $(this).data('scp')
				, bk = $(this).data('bk')
				;

			scp = (that.page || '*.*') + '.' + scp + '.' + Math.random().toString(34).slice(2, 2 + 5);

			if( scp ){
				tgs.trackSCP(scp, bk, traceId);
			}
		});
	}

	/**
	 * 初始化回到顶部按钮
	 * 不需要此功能：that.goToTop = false;
	 * 需要此功能：不传值或者，that.goToTop = true;
	 */
	_initScrollUp(options={}){
		let that = this
			, settings = _.defaults({
				scrollName: 'scrollToTop'
				, topDistance: '300'
				, topSpeed: 300
				, animationInSpeed: 200
				, animationOutSpeed: 200
				, scrollText: 'Scroll to top'
				, goToTop: true
			}, options)
			, sn = '#' + settings.scrollName
			, os = settings.animationOutSpeed
			, is = settings.animationInSpeed
			, td = settings.topDistance
			, ts = settings.topSpeed
			;

		// 搜索页面
		if( that.useGoTop ){
			if (location.href.indexOf('product/listing.html')) {
				that.$goToSearchDOM = $('<a id="topSearch" style="display:none" href="/#/search?type=index&placeholder=放心购物上天狗&searchFromPage=listing"><div class="pos-f right0" style="bottom:130px;z-index:1"><img src="//image1.51tiangou.com/tgou2/img2/index/topSearch.png" height="40" alt=""></div></a>').appendTo('body');
			} else {
				that.$goToSearchDOM = $('<a id="topSearch" style="display:none" href="/#/search?type=index&placeholder=放心购物上天狗"><div class="pos-f right0" style="bottom:130px;z-index:1"><img src="//image1.51tiangou.com/tgou2/img2/index/topSearch.png" height="40" alt=""></div></a>').appendTo('body');
			}
			that.$goToTopDOM = $('<a href="#top" id="' + settings.scrollName + '" style="z-index:999;"><img src="//image1.51tiangou.com/tgou2/img2/index/scrollToTop.png" width="40"/></a>').appendTo('body');
		}

		if( settings.goToTop ){
			$(window).scroll(function(){
				($(window).scrollTop() > td) ? $(sn).fadeIn(is) : $(sn).fadeOut(os);
			});
		}

		$(sn).click(function(){
			$('html, body').animate({
				scrollTop: 0
			}, ts);
			tgs.trackSCP(that.page + '.gtop.00.' + Math.random().toString(34).slice(2, 2 + 5));

			return false;
		});
	}

	_brownShare(){
		let that = this
			, href = that.removeParams(location.href, 'cityId', 'shareSource', 'scp')
			, opt = {
				link: that.addParams(href, {
					cityId: that.cityId
					, shareSource: 'browser'
				})
			}
			, title
			;

		opt = $.extend({}, that.getWcParam(), (that.dynamicWcShare || {}), opt);
		title = opt.friendTitle || '【大商天狗】大商集团电商平台';
		document.title = that.pageTitle || title;

		if( !that.hybrid && !that.isAirMall && maple.device.weixin ){
			let $iframe = $('<iframe width="0" height="0" src="//image1.51tiangou.com/tgou2/img2/favicon.ico"></iframe>').on('load', function(){
					setTimeout(function(){
						$iframe.off('load').remove();
					}, 0);
				}).appendTo(that.$body)
				;
		}

		$(document.getElementsByTagName('meta')['apple-mobile-web-app-title']).attr('content', title);
		$('link[rel="apple-touch-icon"]').attr('href', opt.imgUrl);
	}

	_initWcShare(){
		let that = this
			;

		api.weixin.sign({
			data: {
				url: location.href
			}
			, success: function(data){
				data.jsApiList.push('chooseImage'); // 选择照片
				data.jsApiList.push('scanQRCode');  // 扫二维码
				data.jsApiList.push('uploadImage'); // 上传图片
				data.jsApiList.push('downloadImage');   // 下载图片
				// 语言相关
				data.jsApiList.push('startRecord');
				data.jsApiList.push('stopRecord');
				data.jsApiList.push('onVoiceRecordEnd');
				data.jsApiList.push('playVoice');
				data.jsApiList.push('pauseVoice');
				data.jsApiList.push('stopVoice');
				data.jsApiList.push('onVoicePlayEnd');
				data.jsApiList.push('uploadVoice');
				data.jsApiList.push('downloadVoice');

				data.jsApiList.push('translateVoice');

				data.jsApiList.push('getLocation');

				// 新版分享 api
				data.jsApiList.push('updateAppMessageShareData', 'updateTimelineShareData');

				data.openTagList = ['wx-open-launch-weapp'];

				weChat.sign(data, function(){
					try{
						if( that.useWcShare ){
							let url = that.removeParams(location.href, 'scrollTop', 'cityId', 'shareSource', 'first', 'scp')
								, opt = $.extend({}, that.getWcParam(), (that.dynamicWcShare || {}))
								;

							opt['link'] = opt['link'] || that.addParams(url, {
								cityId: that.cityId
								, shareSource: 'wc'
							});

							weChat.setShare( opt );
						}
						else{
							weChat.hideMenu();
						}
					}
					catch(e){}
					finally{}
				});
			}
		});
	}

	getWcParam(){
		return {
			title: '【大商天狗】大商集团电商平台'    // 分享标题
			, subTitle: 'm.51tiangou.com'           // 分享描述
			, friendTitle: '【大商天狗】大商集团电商平台'
		};
	}

	getBusPage(val){
		let pathname = location.pathname === '/' ? '/index.html' : location.pathname
			, item = currentPageCode[pathname] || {}
			, page = (item.key || []).join('.') || undefined
			, bk = item.bk
			, bkParam = (item.bkParam || '').split(',')
			, bkVar = item.bkVar
			, bkValue
			, params = this.params || {}
			;

		bkValue = (bkVar && this[bkVar]);

		if( !bkValue ){
			for( let i = 0; i < bkParam.length; i++ ){
				if( params[bkParam[i]] ){
					bkValue = params[bkParam[i]];
					break;
				}
			}

			bkValue = bkValue || params['id'];
		}

		if( bk && (val || bkValue) ){
			page = page || '*.*';

			return {
				pagebk: page + '.' + bk + '-' + (val || bkValue)
				, page: page
			};
		}
		else{
			return {
				pagebk: page
				, page: page
			};
		}
	}

	/**
	 * 自动统计
	 * @private
	 */
	_initAutoAnalyse(ops={}){
		let that = this
			, pageTempObject = this.getBusPage()
			;

		that.pagebk = _.get(pageTempObject, 'pagebk', '*.*');
		that.page = _.get(pageTempObject, 'page', '*.*');

		// 自动统计页面
		if( !that.autoAnalyse ){
			return false;
		}

		if( this.hybrid ){
			app.constructor.tgTrackPage = function(){
				try{
					_tgs.trackPage(_.defaults(ops, {
						page: that.pagebk
						, cityId: that.cityId
						, storeId: that.storeId
					}));
				}
				catch(e){}
			};
		}
		else{
			try{
				tgs.trackPage( _.defaults(ops, {
					page: that.pagebk
				}) );
			}
			catch(e){}
		}
	}

	_initAutoBaoguang(){
		// 每500ms检查一次曝光并发送
		traceTimer = setInterval(() => {
			this.startBaoguang();
		},500);
	}

	/**
	 * 自动拉起 app
	 * @private
	 */
	_autoRunApp(){
		// 1.获取当前页面的 url 地址
		let that = this
			, search = location.search
			, localHref = location.pathname
			, opt = _.defaults({}, {
				hasUrl: true
				, hasCode: true
			}, (that.appConfig || {}))
			, iframe
			, code
			, appUrl
			, obj
			;

		if( that.hybrid || that.isAirMall || maple.device.weixin || that.getCookie('goApp') ){
			return false;
		}

		// 2.通过 appPageCode.json 获取当前页面是否有 appCode，组装 iframe 的 src：tgou://m.51tiangou.com?code=xxxx&url=xxxx
		code = AppPageCode[localHref];
		appUrl = 'tgou://m.51tiangou.com';
		obj = {};

		// 根据页面配置加载 url 和 code
		if( opt.hasUrl ){
			obj.url = opt.url || (localHref + search);
		}

		if( opt.hasCode && code ){
			obj.code = opt.code || (code + search);
		}

		appUrl = this.addParams(appUrl, obj);

		// 设置 cookie 保证只跳转一次App
		that.setCookie('goApp', true);

		// 通过 iframe 跳转 App
		iframe = document.createElement('iframe');
		iframe.style.cssText = 'display:none;width:0px;height:0px;';
		iframe.src = appUrl;
		document.body.appendChild( iframe );
	}

	runBusinessCode(initPage, after=function(){}){
		let that = this
            ;

		$.when(cityDeferred, memberInfoDeferred, appInterfaceDeferred).done(function(cityInfo){
			let [cityId, cityName] = cityInfo
                ;

			that.setCookie('cityId', cityId, '365d');
			that.setCookie('cityName', cityName, '365d');
			that.setCookie('validate', 1, '365d');
			checkClientStatus();
			initPage.call( that );
			after();
			nodelog.openIdLog( !!maple.cookie('openid') );        //发送
			that.pageInitOver = true;
		}).fail(function(){
			that.setCookie('validate', 1, '365d');
			checkClientStatus();
			initPage.call( that );
			after();
			that.pageInitOver = true;
		});
		positionRun( cityDeferred );
		checkLoginRun(memberInfoDeferred, that.isWcAutoLogin);
		loadAppInterface( appInterfaceDeferred );
	}
}

function checkClientStatus(){
	let img
        ;

	if( maple.cookie('isLogin') === 'true' && !maple.cookie('memberId') ){
		try{
			img = new Image();
			img.src = '//node.' + domain.tgDomain + '/monitor/memberIdNone.gif?type=memberIdLost';
		}
		catch(e){}
	}
}

_.defaults(Page.prototype, base);

let factory = function(options={}){
	let { init = function(){}
		, initPage = function(){} } = options
        , ins = new Page( init )
        ;

	for( let i in options ){
		ins[i] = options[i];
	}

	ins.pageCodeJson = currentPageCode;

	// 设定默认参数
	maple.pageIns = $.that = ins;
	ins._initPage( initPage );
};
export {$, maple, domain, api, tgs, app, request, factory};